import { commonReducer } from './reducers/common.reducer';
import { flightReducer } from './reducers/flight.reducer';

export const rootReducers = { common: commonReducer, flight: flightReducer };
